// export const SHEET_HEIGHT = '95svh';
export const SHEET_HEIGHT =
  'calc(95svh - var(--offset-bottom) - var(--offset-top))';
export const SHEET_HEADER_HEIGHT = '83px';
export const SHEET_FOOTER_HEIGHT = '57px';
